import React, { useEffect, useState } from 'react'
import { PageHeader } from '../../../shared/components'
import { CostCenterDto } from 'appDtos';
import { Container, ListGroup } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { AdministrationPaths } from '../../../shared/api/constants';
import { AppPaths } from '../../../shared/appConstants';
import { AlertComponent } from '../../../shared/components';
import { Loading } from '../../../shared/components';
import { useApi } from '../../../shared/hooks/useApi';
import { useApiHandleError } from '../../../shared/hooks/useApiHandleError';

export function CostCenters() {
  const [costCenters, setCostCenters] = useState<CostCenterDto[]>([]);
  const [loading, setLoading] = useState(true);
  const API = useApi();
  const { setError, errorMessage } = useApiHandleError();
  const goTo = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const response = await API.get(AdministrationPaths.GetCostCenters());
        if (response.data) {
          setCostCenters(response.data);
        }
      } catch (error) {
        setError(error)
      }
      setLoading(false);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container>
      <PageHeader pageTitle='Cost Centers' navPath={AppPaths.getCreateCostCenter()} />
      <AlertComponent message={errorMessage} />
      {loading ? (
        <Loading />
      ) : (
        costCenters.length > 0 ?
          <ListGroup numbered as="ol">
            {
              costCenters.map((costCenter, i) => (
                <ListGroup.Item key={costCenter.costCenterId} action as="li" className="d-flex justify-content-between align-items-start clicable" onClick={() => goTo(AppPaths.getCostCenterDetail(costCenter.costCenterId))}>
                  <div className="ms-2 me-auto">
                    <div className="fw-bold">{costCenter.name}</div>
                  </div>
                </ListGroup.Item>
              ))
            }
          </ListGroup>
          : (
            <AlertComponent message="No cost center has been created." variant="info" />
          )
      )}
    </Container>)
}
